import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Typography } from '@mui/material';
import type { StarRatingTooltipProps } from './Monetizable';
import type { TooltipActionType } from './types';
interface StarRatingTooltipContentProps extends StarRatingTooltipProps {
  handleTooltipClickPageAction: (actionType: TooltipActionType, actionSection: string) => void;
}
export function StarRatingTooltipContent({
  position = 'bottom',
  maxWidth = 240,
  mobileColor,
  mobileFontVariant,
  segmentActionSection,
  handleTooltipClickPageAction
}: StarRatingTooltipContentProps) {
  const text = <Typography sx={theme => ({
    padding: 1,
    paddingBottom: 3,
    color: theme.palette.common.black,
    [theme.breakpoints.down('md')]: {
      color: mobileColor ? mobileColor : theme.palette.grey[500],
      fontFamily: mobileFontVariant ? mobileFontVariant : theme.typography.textSmall,
      paddingBottom: 0
    }
  })}>
      NerdWallet&apos;s ratings are determined by our editorial team. The scoring formula takes into
      account the type of card being reviewed (such as cash back, travel or balance transfer) and
      the card&apos;s rates, fees, rewards and other features.
    </Typography>;
  return <InfoTooltip ariaLabel="How are NerdWallet's ratings determined?" text={text} position={position} maxWidth={maxWidth} onOpen={() => handleTooltipClickPageAction('open', segmentActionSection || '')} onClose={() => handleTooltipClickPageAction('close', segmentActionSection || '')} onBlur={() => handleTooltipClickPageAction('close', segmentActionSection || '')} />;
}